'use strict';

var MC_SPINOPTS = {
  lines: 17, // The number of lines to draw
  length: 0, // The length of each line
  width: 15, // The line thickness
  radius: 30, // The radius of the inner circle
  corners: 1, // Corner roundness (0..1)
  rotate: 0, // The rotation offset
  direction: 1, // 1: clockwise, -1: counterclockwise
  //color: '#000', // #rgb or #rrggbb or array of colors
  color: ['#0064AD'], // #rgb or #rrggbb or array of colors
  
  speed: 1, // Rounds per second
  trail: 80, // Afterglow percentage
  shadow: false, // Whether to render a shadow
  hwaccel: false, // Whether to use hardware acceleration
  className: 'spinner', // The CSS class to assign to the spinner
  zIndex: 200, // The z-index (defaults to 2000000000) - runter auf 200 sonst überlagert es die Modals etc. 
  top: '50%', // Top position relative to parent
  left: '50%' // Left position relative to parent
};
